{
  "title": "Negative Energy Flood",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "5th-level necromancy",
  "level": 5,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, M (a broken bone and a square of black silk)",
  "duration": "Instantaneous",
  "description": [
    "You send ribbons of negative energy at one creature you can see within range. Unless the target is undead, it must make a Constitution saving throw, taking 5d12 necrotic damage on a failed save, or half as much damage on a successful one. A target killed by this damage rises up as a zombie at the start of your next turn. The zombie pursues whatever creature it can see that is closest to it. Statistics for the zombie are in the Monster Manual. If you target an undead with this spell, the target doesn’t make a saving throw. Instead, roll 5d12. The target gains half the total as temporary hit points."
  ],
  "spellLists": ["warlock", "wizard"]
}
